import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  nodeAtPath1cd3xt81xpfir as nodeAtPath,
  deepMergeObject115s855ldv6gd as deepMergeObject,
  toJsonMaprsmqd9lb9sfm as toJsonMap,
} from './JsonMap.mjs';
import { DeferredFragmentIdentifieryfmj5mbsp1mh as DeferredFragmentIdentifier } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/DeferredFragmentIdentifier.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function incrementalResult($this, incrementalResult) {
  var tmp = incrementalResult.u4('data');
  var data = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : THROW_CCE();
  var tmp_0 = incrementalResult.u4('path');
  var path = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = $this.b6e_1.u4('data');
  var mergedData = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
  if (!(data == null)) {
    var tmp_2 = nodeAtPath(mergedData, path);
    var nodeToMergeInto = (!(tmp_2 == null) ? isInterface(tmp_2, KtMutableMap()) : false) ? tmp_2 : THROW_CCE();
    deepMergeObject(nodeToMergeInto, data);
    var tmp0 = $this.c6e_1;
    var tmp_3 = incrementalResult.u4('label');
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (DeferredFragmentIdentifier())(path, (tmp_3 == null ? true : typeof tmp_3 === 'string') ? tmp_3 : THROW_CCE());
    tmp0.i2(element);
  }
}
var V0_1IncrementalResultsMergerClass;
function V0_1IncrementalResultsMerger() {
  if (V0_1IncrementalResultsMergerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.a6e_1 = LinkedHashMap().ec();
        this.b6e_1 = this.a6e_1;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp_0.c6e_1 = LinkedHashSet().s2();
        this.d6e_1 = this.c6e_1;
        this.e6e_1 = true;
        this.f6e_1 = false;
      }
      g6e() {
        return this.d6e_1;
      }
      h6e() {
        return this.e6e_1;
      }
      i6e() {
        return this.f6e_1;
      }
      j6e(part) {
        return this.k6e(toJsonMap(part));
      }
      k6e(part) {
        if (this.b6e_1.n1()) {
          // Inline function 'kotlin.collections.plusAssign' call
          this.a6e_1.z4(part);
          return this.b6e_1;
        }
        var tmp = part.u4('incremental');
        var incremental = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
        if (incremental == null) {
          this.f6e_1 = true;
        } else {
          this.f6e_1 = false;
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedErrors = ArrayList().p2();
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedExtensions = ArrayList().p2();
          var _iterator__ex2g4s = incremental.p1();
          while (_iterator__ex2g4s.q1()) {
            var incrementalResult_0 = _iterator__ex2g4s.r1();
            incrementalResult(this, incrementalResult_0);
            var tmp_0 = incrementalResult_0.u4('errors');
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(mergedErrors, tmp0_safe_receiver);
            }
            var tmp_1 = incrementalResult_0.u4('extensions');
            var tmp1_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              mergedExtensions.i2(tmp1_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedErrors.n1()) {
            // Inline function 'kotlin.collections.set' call
            this.a6e_1.x4('errors', mergedErrors);
          } else {
            this.a6e_1.y4('errors');
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedExtensions.n1()) {
            var tmp0 = this.a6e_1;
            var tmp2 = 'extensions';
            // Inline function 'kotlin.collections.set' call
            var value = mapOf(to('incremental', mergedExtensions));
            tmp0.x4(tmp2, value);
          } else {
            this.a6e_1.y4('extensions');
          }
        }
        var tmp_2 = this;
        var tmp_3 = part.u4('hasNext');
        var tmp2_elvis_lhs = (tmp_3 == null ? true : typeof tmp_3 === 'boolean') ? tmp_3 : THROW_CCE();
        tmp_2.e6e_1 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
        return this.b6e_1;
      }
      j3p() {
        this.a6e_1.a5();
        this.c6e_1.a5();
        this.e6e_1 = true;
        this.f6e_1 = false;
      }
    }
    initMetadataForClass($, 'V0_1IncrementalResultsMerger', V0_1IncrementalResultsMerger);
    V0_1IncrementalResultsMergerClass = $;
  }
  return V0_1IncrementalResultsMergerClass;
}
//region block: exports
export {
  V0_1IncrementalResultsMerger as V0_1IncrementalResultsMerger33xbt4nwq2a5,
};
//endregion

//# sourceMappingURL=V0_1IncrementalResultsMerger.mjs.map
